import React, { useState, useEffect } from 'react'
import { T, Spinner, Avatar, probColor, tdColor, inGameFilter, PosFilter, POS_GROUPS, posOf } from '../ui'
import { getNFLDueTds } from '../api'
import { teamNick } from '../plain'

// DUE board — players the model still projects to score who've gone cold, with their recent
// touches shown so a usage collapse never reads as "due." Positive-regression VALUE, framed
// honestly: a cold streak doesn't make a TD likelier — this is usage the finish hasn't matched.

function DueRow({ r, onPlayer }) {
  return (
    <button onClick={() => onPlayer && onPlayer({ gsis_id: r.gsis_id, full_name: r.name, team: r.team, pos: r.pos, opp: r.opp, prop_type: 'anytime_td' })}
      style={{ display: 'flex', width: '100%', alignItems: 'center', gap: 11, textAlign: 'left', cursor: 'pointer',
        background: T.card, border: `1px solid ${T.border}`, borderRadius: 12, padding: '11px 13px', marginBottom: 8, color: T.text }}>
      <Avatar url={r.headshot} name={r.name} team={r.team} size={34} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14.5, fontWeight: 800, lineHeight: 1.2 }}>{r.name}</div>
        <div style={{ fontSize: 11, color: T.muted, fontWeight: 700, marginTop: 2 }}>{r.pos} · {teamNick(r.team)} vs {teamNick(r.opp)}</div>
        <div style={{ fontSize: 10.5, color: T.muted, marginTop: 2 }}>
          Last TD {r.last_td} · {r.avg_touches} touches/g · {r.season_tds} TDs in {r.games}g</div>
      </div>
      <div style={{ flex: 'none', textAlign: 'center', marginRight: 2 }}>
        <div style={{ fontFamily: T.mono, fontWeight: 900, fontSize: 16, color: T.amber }}>{r.drought}g</div>
        <div style={{ fontSize: 10, color: T.muted, fontWeight: 800, letterSpacing: '0.05em' }}>COLD</div>
      </div>
      <div style={{ fontFamily: T.mono, fontWeight: 900, fontSize: 17, color: tdColor((r.prob || 0) / 100), minWidth: 46, textAlign: 'right' }}>
        {r.prob}%</div>
    </button>
  )
}

export default function DueTab({ season = 2026, week = 1, onPlayer, gameFilter }) {
  const [d, setD] = useState(null)
  const [pos, setPos] = useState('ALL')
  useEffect(() => { let a = true; setD(null)
    getNFLDueTds(season, week, 50, { minTouches: 6 }).then(r => { if (a) setD(r) }).catch(() => { if (a) setD({ due: [] }) })
    return () => { a = false } }, [season, week])
  if (!d) return <div style={{ padding: 20 }}><Spinner /></div>
  const inGame = (d.due || []).filter(r => inGameFilter(gameFilter, r.team))
  const counts = Object.fromEntries(POS_GROUPS.map(g => [g, g === 'ALL' ? inGame.length : inGame.filter(r => posOf(r) === g).length]))
  const due = pos === 'ALL' ? inGame : inGame.filter(r => posOf(r) === pos)
  return (
    <div style={{ padding: '12px 14px 90px' }}>
      <div style={{ fontSize: 12, color: T.muted, marginBottom: 12, lineHeight: 1.45 }}>
        Still projected to score — but they’ve gone <b style={{ color: T.amber }}>cold</b>. The touches are there, the finishes
        haven’t come. Not “he’s due” — this is <b style={{ color: T.text }}>positive-regression value</b>. <span style={{ color: T.faint }}>COLD = games since last TD.</span></div>
      {inGame.length > 0 && <div style={{ marginBottom: 10 }}><PosFilter value={pos} onChange={setPos} counts={counts} /></div>}
      {due.length === 0
        ? <div style={{ fontSize: 12, color: T.muted, padding: '24px 0', textAlign: 'center' }}>
            Needs a few games of history to call a drought — fills in as the season banks weeks.</div>
        : due.map((r, i) => <DueRow key={r.gsis_id || i} r={r} onPlayer={onPlayer} />)}
    </div>
  )
}
